var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { gql, useMutation } from "@apollo/client";
import { entityFieldMutationFragment } from "../utils/entity-field-mutation-fragment";
import { graphql } from "@shapeable/graphql";
export var entityMutationName = function (type, entityTypeName) {
  return "".concat(type.toLowerCase()).concat(entityTypeName);
};
export var entityMutationQuery = function (_a) {
  var type = _a.type,
    entityTypeName = _a.entityTypeName,
    _b = _a.fields,
    fields = _b === void 0 ? [] : _b;
  var mutationName = entityMutationName(type, entityTypeName);
  var mutationQueryArgs = {
    Update: "$id: ID!, $input: ".concat(entityTypeName, "Input!"),
    Patch: "$id: ID!, $input: ".concat(entityTypeName, "PatchInput!"),
    Create: "$input: ".concat(entityTypeName, "Input!"),
    Delete: "$id: ID!"
  };
  var mutationArgs = {
    Update: 'id: $id, input: $input',
    Patch: 'id: $id, input: $input',
    Create: 'input: $input',
    Delete: 'id: $id'
  };
  // Replace the existing mutation query block with the following:
  // Set up Delete mutation query block as we can't return the entity subfields
  // Not sure if this is the best way to handle this.
  var mutation = type === 'Delete' ? graphql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        mutation ", "", "Mutation(", ") {\n          ", "(", ")\n        }\n      "], ["\n        mutation ", "", "Mutation(", ") {\n          ", "(", ")\n        }\n      "])), entityTypeName, type, mutationQueryArgs[type], mutationName, mutationArgs[type]) : graphql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        mutation ", "", "Mutation(", ") {\n          ", "(", ") {\n            id\n            name\n            slug\n            updated\n            ...EntityOpenGraphFieldsDetails\n            ...EntityViews\n            ", "\n          }\n        }\n      "], ["\n        mutation ", "", "Mutation(", ") {\n          ", "(", ") {\n            id\n            name\n            slug\n            updated\n            ...EntityOpenGraphFieldsDetails\n            ...EntityViews\n            ", "\n          }\n        }\n      "])), entityTypeName, type, mutationQueryArgs[type], mutationName, mutationArgs[type], fields.map(function (fieldDefn) {
    return entityFieldMutationFragment(fieldDefn);
  }).join('\n'));
  return mutation;
};
// export type UseEntityMutationsResult = Partial<Record<EntityTypeName, Record<EntityMutationType, UseEntityMutationResult>>>;
// export type UseEntityMutationsResultPartial = Partial<Record<EntityTypeName, Partial<Record<EntityMutationType, UseEntityMutationResult>>>>;
// export const useEntityMutations: (items: Omit<UseEntityMutationArgs, 'type'>[]) => UseEntityMutationsResult = 
//   (items) => {
//     const client = useApolloClient();
//     const mutations: UseEntityMutationsResultPartial = {};
//     const allTypes: EntityMutationType[] = ['Create', 'Update', 'Delete'];
//     items.forEach((arg) => {
//       const { entityTypeName, fields } = arg;
//       for (const type of allTypes) {
//         if (!mutations[entityTypeName]) {
//           mutations[entityTypeName] = {};
//         }
//         const mutationQuery = entityMutationQuery({ type, entityTypeName, fields });
//         const [ submit, { data, loading, error } ] = useMutation(gql`${mutationQuery}`);
//         const tuple = [ submit, { data: data?.[mutationQuery], loading, error } ];
//         mutations[entityTypeName][type] = [ submit, { data: data?.[mutationQuery], loading, error } ];
//       }
//     });
//     return mutations;
//   };
export var useEntityMutation = function (_a) {
  var type = _a.type,
    entityTypeName = _a.entityTypeName,
    _b = _a.fields,
    fields = _b === void 0 ? [] : _b;
  var mutationQuery = entityMutationQuery({
    type: type,
    entityTypeName: entityTypeName,
    fields: fields
  });
  var _c = __read(useMutation(gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), mutationQuery)), 2),
    submit = _c[0],
    _d = _c[1],
    data = _d.data,
    loading = _d.loading,
    error = _d.error;
  return {
    result: data === null || data === void 0 ? void 0 : data[mutationQuery],
    submit: submit,
    loading: loading,
    mutationQuery: mutationQuery,
    error: error
  };
};
var templateObject_1, templateObject_2, templateObject_3;